import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from "i18next-resources-to-backend";
 
i18n
    .use(
        resourcesToBackend((lng, ns) => {
            // Explicitly map new namespaces to avoid runtime misses in dynamic context.
            if (lng === 'ua' && ns === 'Document') return import('./locales/ua/Document.json');
            if (lng === 'en' && ns === 'Document') return import('./locales/en/Document.json');
            if (lng === 'ua' && ns === 'TemplateValueKeys') return import('./locales/ua/TemplateValueKeys.json');
            if (lng === 'en' && ns === 'TemplateValueKeys') return import('./locales/en/TemplateValueKeys.json');
            return import(`./locales/${lng}/${ns}.json`);
        }),
    ) // Динамічний імпорт
    .use(initReactI18next)      // Інтеграція з React
    .init({
        fallbackLng: 'ua',      // Резервна мова
        lng: 'ua',              // Мова за замовчуванням
        defaultNS: 'common',    // Нейспейс за замовчуванням
        interpolation: {
            escapeValue: false, // Без екранування для React
        },
        react: {
            useSuspense: true,  // Увімкнення режиму очікування
        },
    });

export default i18n;


/*
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// мовні модулі
import en from './locales/en.json';
import ua from './locales/ua.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ua: { translation: ua },
    },
    lng: 'en', // Мова за замовчуванням
    fallbackLng: 'en', // Резервна мова
    interpolation: {
        escapeValue: false, // Не потрібне екранування для React
    },
});

export default i18n;

/** 
 * Для зміни мови використовувати 
 * const { t } = useTranslation();
 * i18n.changeLanguage('ua');
 */
